import ScLoan from './sdk/las';

(function (window: Window) {
  // eslint-disable-next-line no-param-reassign
  window.ScLoan = ScLoan;
})(window);
